module.exports = __webpack_public_path__ + "static/img/logo-lgunicharm.5c70048.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-lgunicharm.png
// module id = 2m1G
// module chunks = 0